import { jsx, Fragment } from 'react/jsx-runtime';
import { memo, useMemo } from 'react';
import useStyles from './SystemMarker.styles.js';
import { useWarzoneMapSystem } from '../context/warzone-map.js';
var SystemMarker = memo(function (_ref) {
  var solarsystemId = _ref.solarsystemId,
    classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 192 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 192 : _ref$height;
  var _useWarzoneMapSystem = useWarzoneMapSystem(solarsystemId),
    data = _useWarzoneMapSystem.data,
    type = _useWarzoneMapSystem.type,
    adjacency = _useWarzoneMapSystem.adjacency;
  var _useStyles = useStyles(void 0, {
      name: "WarzoneMapSystemMarker",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes;
  return useMemo(function () {
    if (type !== "system") return /* @__PURE__ */jsx(Fragment, {});
    return /* @__PURE__ */jsx("use", {
      xlinkHref: "#".concat(adjacency, "-marker"),
      id: "marker-".concat(solarsystemId),
      x: data.x - width / 2,
      y: data.y - height / 2,
      width: width,
      height: height,
      className: classes.markerSymbol
    });
  }, [data, type, adjacency, classes, solarsystemId, width, height]);
});
SystemMarker.displayName = "WarzoneMapSystemMarker";
export { SystemMarker };